import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import KineticText from "@/components/motion/KineticText";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1 text-sm text-gray-500" data-testid="breadcrumbs">
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-gray-300" />}
          {it.path ? (
            <Link to={it.path} className="hover:text-[#0B63F6] transition-colors">{it.name}</Link>
          ) : (
            <span className="text-[#111111] font-medium">{it.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

export default function PageHero({ eyebrow, titleLines = [], title, sub, breadcrumbs, children }) {
  return (
    <section className="relative overflow-hidden bg-white pt-32 lg:pt-40 pb-14 lg:pb-20 border-b border-gray-100">
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div
        className="absolute -top-20 right-0 h-[420px] w-[520px] rounded-full blur-3xl pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(11,99,246,0.08), transparent 70%)" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {breadcrumbs && <div className="mb-8"><Breadcrumbs items={breadcrumbs} /></div>}
        {eyebrow && (
          <motion.p initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B63F6]">
            {eyebrow}
          </motion.p>
        )}
        <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tightest leading-[1.02] mt-4 max-w-4xl text-[#111111]">
          {titleLines.length ? <KineticText lines={titleLines} /> : title}
        </h1>
        {sub && (
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.3 }} className="text-lg text-gray-600 mt-6 max-w-2xl leading-relaxed">
            {sub}
          </motion.p>
        )}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
